import React from 'react';
import styles from './LiveUnloadPlannerCard.module.css';

export function PlannerCardKvColumn({ title, rows }) {
  return (
    <div className={styles.kvColumnBox}>
      <h3 className={styles.colTitle}>{title}</h3>
      {(rows || []).map((row, i) => (
        <p key={`${row.label}-${i}`} className={styles.kv}>
          <span className={styles.kvLabel}>{row.label}</span>
          <span className={styles.kvValue}>{row.value}</span>
        </p>
      ))}
    </div>
  );
}
